import { Socket, io } from "socket.io-client";
import { toastMessage } from "./toast";

let socket: Socket | null = null;

const URL = `${import.meta.env.REACT_APP_SOCKET_URL}/admin`;

export const initializeSocket = (token: string, studyId: string): void => {
  socket = io(URL, {
    path: "/api/socket.io",
    upgrade: true,
    extraHeaders: {
      Authorization: `Bearer ${token}`,
      "x-study-id": studyId,
    },
    autoConnect: false,
    reconnectionAttempts: 5,
  });
};

export const connectSocket = () => {
  if (!socket) {
    toastMessage("error", "Socket has not been initialized");
    return;
  }
  if (!socket.connected) {
    socket.connect();
  }
};

export const getSocket = () => {
  if (!socket) {
    toastMessage("error", "Socket has not been initialized");
    return;
  }
  return socket;
};

export const resetSocket = (): void => {
  socket?.disconnect();
  socket = null;
};
